import { Injectable, signal } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class SessionExpiredService {
    private readonly _isExpired = signal(false);
    readonly isExpired = this._isExpired.asReadonly();

    markExpired(): void {
        this._isExpired.set(true);
    }
}
